"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const icons_1 = require("@icr-ui/icons");
const styles_1 = require("./styles");
const organisms_1 = require("../../../organisms");
const general_1 = require("../../../general");
const theme_1 = require("@icr-ui/theme");
const hooks_1 = require("@icr-ui/hooks");
const Notification = ({ notifications, hasUnread = false }) => {
    const [isOpen, setIsOpen] = (0, react_1.useState)(false);
    const innerRef = (0, hooks_1.useClickOutside)(() => setIsOpen(false));
    return ((0, jsx_runtime_1.jsxs)(styles_1.StyledNotificationWrapper, { onClick: () => setIsOpen(!isOpen), ref: innerRef, ...{ isOpen }, children: [hasUnread ? (0, jsx_runtime_1.jsx)(icons_1.NotificationNewIcon, {}) : (0, jsx_runtime_1.jsx)(icons_1.NotificationIcon, {}), (0, jsx_runtime_1.jsx)(styles_1.StyledNotificationContent, { children: notifications === null || notifications === void 0 ? void 0 : notifications.map(({ title, description }, index) => {
                    const lastItem = notifications.lastIndexOf(notifications[notifications.length - 1]);
                    return ((0, jsx_runtime_1.jsxs)(react_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(organisms_1.NotificationBanner, { title: title, description: description }, index), lastItem !== index && (0, jsx_runtime_1.jsx)(general_1.Divider, { borderColor: theme_1.grayScale[200] })] }, index));
                }) })] }));
};
exports.default = Notification;
//# sourceMappingURL=notification.js.map